// src/components/auth/AuthenticationRequired.tsx
import { FC, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/hooks/useAuth";
import { canAccessFrontoffice } from "@/auth/roleAccess";
import { useSession } from "@/broadcastChannel/useSession";

interface Props {
  children: ReactNode;
  redirect: string;
}

const AuthenticationRequired: FC<Props> = ({ children, redirect }) => {
  const auth = useAuth();
  const { session } = useSession();
  const navigate = useNavigate();
  const hasPendingImpersonation =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("impersonation");

  useEffect(() => {
    if (!session && !hasPendingImpersonation) {
      console.log("⚠️ Session manquante → redirection login");
      navigate(`/login${redirect ? `?redirect=${redirect}` : ""}`);
    }
  }, [session, hasPendingImpersonation, navigate, redirect]);

  if (!session || hasPendingImpersonation) return null;

  // Optionnel : check complémentaire sur l’utilisateur
  if (
    (!auth.isAuthenticated ||
      !auth.user?.isVerified ||
      auth.user?.roles?.includes("ROLE_ADMIN") ||
      !canAccessFrontoffice(auth.user)) &&
    !auth.loading
  ) {
    navigate(`/login${redirect ? `?redirect=${redirect}` : ""}`);
    return null;
  }

  return <>{children}</>;
};

export default AuthenticationRequired;
